<template>
    <el-drawer :modal="false" 
        :visible.sync="drawerAgentLine"
        class="drawer-agent-line"
        size="60%"
        title="Agent Line"
    >
        <b-container>
            <div>
                <vue-tree-list
                @click="onClick"
                @change-name="onChangeName"
                @delete-node="onDel"
                @add-node="onAddNode"
                :model="data"
                default-tree-node-name="new node"
                default-leaf-node-name="new leaf"
                v-bind:default-expanded="true"
                >
                    <template v-slot:leafNameDisplay="slotProps">
                        <b-card no-body class="p-3 m-0">
                            <b-row align-h="between">
                                <b-col cols="auto" class="d-flex align-items-center">
                                    <p class="font-weight-500">{{ slotProps.model.name }}</p>
                                    <div v-if="slotProps.model.position">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="8" height="8" viewBox="0 0 512 512"><path fill="#DEE5EF" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                                        <span class="text-xs text-muted">{{ slotProps.model.position }}</span>
                                    </div>
                                </b-col>
                                <b-col cols="auto" class="d-flex align-items-center" v-if="!slotProps.model.isLeaf">
                                    <span class="font-xs text-primary">10</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="12" viewBox="0 0 640 512"><path fill="#5D79E3" d="M144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm368 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7-1.3 7.2-1.9 14.7-1.9 22.3 0 38.2 16.8 72.5 43.3 96H21.3C9.6 320 0 310.4 0 298.7zM405.3 320h-.7c26.6-23.5 43.3-57.8 43.3-96 0-7.6-.7-15-1.9-22.3 13.6-6.3 28.7-9.7 44.6-9.7h42.7c58.9 0 106.7 47.8 106.7 106.7 0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm-96 261.3c0-73.6 59.7-133.3 133.3-133.3h117.4c73.6 0 133.3 59.7 133.3 133.3 0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/></svg>
                                </b-col>
                                <b-col cols="auto" class="d-flex align-items-center" v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 128 512"><path fill="#A4B0C0" d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm56-104A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/></svg>
                                </b-col>
                            </b-row>
                            <b-row align-h="between" v-if="slotProps.model.commission">
                                <b-col cols="auto">
                                    <p class="font-weight-600">{{ slotProps.model.commission }}% Comm.</p>
                                </b-col>
                                <b-col cols="auto" class="d-flex align-items-center text-muted" v-if="slotProps.model.upline">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="12" height="16" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-14.9 103.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3 70.1 17.6 121.9 81 121.9 156.4 0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8.7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4 8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"/></svg>
                                    <span class="font-xs text-muted">Ruby</span>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:addTreeNodeIcon="slotProps">
                        <!-- <span class="icon">📂</span> -->
                        <span class="icon"></span>
                    </template>
                    <template v-slot:addLeafNodeIcon="slotProps">
                        <!-- <span class="icon">＋</span> -->
                        <span class="icon"></span>
                    </template>
                    <template v-slot:editNodeIcon="slotProps">
                        <!-- <span class="icon">📃</span> -->
                        <span class="icon"></span>
                    </template>
                    <template v-slot:delNodeIcon="slotProps">
                        <!-- <span class="icon">✂️</span> -->
                        <span class="icon"></span>
                    </template>
                    <template v-slot:leafNodeIcon="slotProps">
                        <!-- <span class="icon">🍃</span> -->
                        <span class="icon"></span>
                    </template>
                    <template v-slot:treeNodeIcon="slotProps">
                        <!-- <span class="icon">
                            {{ (slotProps.model.children && slotProps.model.children.length > 0 && !slotProps.expanded) ?
                            '🌲' : '' }}
                        </span> -->
                        <span class="icon"></span>
                    </template>
                </vue-tree-list>
            </div>
        </b-container>
    </el-drawer>
</template>
<script>
import { Drawer } from 'element-ui'
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'

export default {
    components: {
        VueTreeList,
        [Drawer.name]: Drawer,
    },
    data() {
        return {
            newTree: {},
            data: new Tree([
                {
                    name: 'Ruby Lim',
                    position: 'Hub Manager',
                    commission: 0.11,
                    id: 1,
                    pid: 0,
                    dragDisabled: true,
                    addTreeNodeDisabled: true,
                    addLeafNodeDisabled: true,
                    editNodeDisabled: true,
                    delNodeDisabled: true,
                    children: [
                        {
                            name: 'Team 1',
                            id: 2,
                            pid: 1,
                            dragDisabled: true,
                            addTreeNodeDisabled: true,
                            addLeafNodeDisabled: true,
                            editNodeDisabled: true,
                            delNodeDisabled: true,
                            children: [
                                {
                                    name: 'Michelle S.',
                                    position: 'Sales Manager',
                                    commission: 0.11,
                                    upline: 'Ruby',
                                    id: 3,
                                    pid: 2,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                                {
                                    name: 'Harisah',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 4,
                                    pid: 2,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                                {
                                    name: 'Esther Yin',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 5,
                                    pid: 2,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                                {
                                    name: 'Terrance K',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 6,
                                    pid: 2,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                            ]
                        },
                        {
                            name: 'Team 2',
                            id: 7,
                            pid: 1,
                            dragDisabled: true,
                            addTreeNodeDisabled: true,
                            addLeafNodeDisabled: true,
                            editNodeDisabled: true,
                            delNodeDisabled: true,
                            children: [
                                {
                                    name: 'Michelle S.',
                                    position: 'Sales Manager',
                                    commission: 0.11,
                                    upline: 'Ruby',
                                    id: 8,
                                    pid: 7,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                    children: [
                                         {
                                            name: 'Emily.',
                                            position: 'Sales Manager',
                                            commission: 0.11,
                                            upline: 'Ruby',
                                            id: 23,
                                            pid: 7,
                                            isLeaf: true,
                                            dragDisabled: true,
                                            addTreeNodeDisabled: true,
                                            addLeafNodeDisabled: true,
                                            editNodeDisabled: true,
                                            delNodeDisabled: true,
                                        },
                                    ]
                                },
                                {
                                    name: 'Harisah',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 9,
                                    pid: 7,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                                {
                                    name: 'Esther Yin',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 10,
                                    pid: 7,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                                {
                                    name: 'Terrance K',
                                    position: 'Mortgage Specialist',
                                    commission: 1.28,
                                    upline: 'Ruby',
                                    id: 11,
                                    pid: 7,
                                    isLeaf: true,
                                    dragDisabled: true,
                                    addTreeNodeDisabled: true,
                                    addLeafNodeDisabled: true,
                                    editNodeDisabled: true,
                                    delNodeDisabled: true,
                                },
                            ]
                        },
                    ]
                },
            ]),
            drawerAgentLine: false,
        }
    },
    methods: {
        viewAgentLine() {
          this.drawerAgentLine = !this.drawerAgentLine;
      },
      onDel(node) {
        console.log(node)
        node.remove()
      },
 
      onChangeName(params) {
        console.log(params)
      },
 
      onAddNode(params) {
        console.log(params)
      },
 
      onClick(params) {
        console.log(params)
      },
 
      addNode() {
        var node = new TreeNode({ name: 'new node', isLeaf: false })
        if (!this.data.children) this.data.children = []
        this.data.addChildren(node)
      },
 
      getNewTree() {
        var vm = this
        function _dfs(oldNode) {
          var newNode = {}
 
          for (var k in oldNode) {
            if (k !== 'children' && k !== 'parent') {
              newNode[k] = oldNode[k]
            }
          }
 
          if (oldNode.children && oldNode.children.length > 0) {
            newNode.children = []
            for (var i = 0, len = oldNode.children.length; i < len; i++) {
              newNode.children.push(_dfs(oldNode.children[i]))
            }
          }
          return newNode
        }
 
        vm.newTree = _dfs(vm.data)
      }
    }
}
</script>